// extracted by mini-css-extract-plugin
module.exports = {"switchWrapper":"PdxToggleSwitch_switchWrapper__2S8Xp","switch":"PdxToggleSwitch_switch__34rtR","label":"PdxToggleSwitch_label__26jUI","slider":"PdxToggleSwitch_slider__358jD"};